<template>
  <div
    v-if="results.length"
    class="omnisearch__results__section"
    :class="{ 'col-12': large, 'col-6': !large }"
  >
    <div class="omnisearch__results__section__header">
      {{ name }}
    </div>
    <div class="omnisearch__results__section__body">
      <div
        v-for="(result, index) in filteredResults"
        class="omnisearch-result"
        :key="index"
      >
        <router-link
          :to="generateLink(result)"
        >
          {{ result[nameKey] }}
          <span v-if="name === 'Users' && large">
            ({{ result.email }})
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 2,
    },
    large: {
      type: Boolean,
      default: false,
    },
    name: {
      required: true,
      type: String,
    },
    results: {
      required: true,
      type: Array,
    },
    link: {
      required: true,
      type: String,
    },
    nameKey: {
      required: false,
      default: 'name',
      type: String,
    },
    param: {
      required: true,
      type: String,
    },
    idKey: {
      required: false,
      type: String,
      default: 'id',
    },
  },

  computed: {
    filteredResults () {
      return this.results.slice(0, this.max)
    },
  },

  methods: {
    generateLink (result) {
      const link = {name: this.link, params: { }}
      link.params[this.param] = result[this.idKey]

      return link
    },
  },
}
</script>
